import { Outlet } from "@remix-run/react";

export default function Blog() {
  return <Outlet />
}